module.exports = __webpack_public_path__ + "static/img/16071B_3_C_20180428_n_fit.a2e82f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16071B_3_C_20180428_n_fit.png
// module id = jyHT
// module chunks = 0